import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("userToken");

  return token ? children : <Navigate to="/admin" replace />;
  // return token ? <Navigate to="/dashboard" replace /> : <Navigate to="/admin" replace />;
};

export default ProtectedRoute;
